<template>
  <v-container fluid tag="section">
    <v-layout justify-center style="flex-wrap: wrap">
     <v-spacer></v-spacer>
      <v-radio-group row justify-center v-model="filterStatus" @change="loadTable()" :label="$t('status')">
        <v-radio :label="$t('all_m_p')" value="all"></v-radio>
        <v-radio :label="$t('already_assigned')" value="assigned"></v-radio>
        <v-radio :label="$t('to_assign')" value="to_assign"></v-radio>
      </v-radio-group>
      <my-datepicker  v-model="validityDate" @input="loadTable" :label="$t('valid_at')"
        required="true" />
      <v-spacer></v-spacer>


    </v-layout>

    <v-row>
      <v-col cols="12">
        <DataTables @showUser="showUser" @saveUserQualifica="saveUserQualifica" @openDiploma="openDiploma" :headers="headers" :tableData="tableData"></DataTables>
      </v-col>
    </v-row>
    <profile-page @isUpdated="loadTable" ref="profilePageDialog"></profile-page>
  </v-container>
</template>

<script>
import DataTables from "@/components/base/DataTables.vue";
import MyDatepicker from "@/components/base/MyDatepicker.vue";
import profilePage from "@/app/UserProfile.vue";

let _ = this;
export default {
  name: "list-users-certificate",
  components: {
    DataTables,
    MyDatepicker,
    profilePage
  },
  data() {
    return {
      filterStatus: "all",
      validityDate: new Date(),
      listDiscipline: [],
      headers: [
        { text: this.$t("avatar"), value: "avatarUrl", type: "image", function: "showUser" },
        { text: this.$t("surname"), value: "surname" },
        { text: this.$t("name"), value: "name" },
        { text: this.$t("fiscal_code"), value: "cFiscale" },
        { text: this.$t("birth_date"), value: "birthDate", type: "date" },
        { text: this.$t("eta"), value: "eta", type: "numeric" },
        { text: this.$t("qualify"), value: "qualificaDex" },
        {
          text: this.$t("type_affiliation_card"),
          value: "tesseraEnte",
          type: "html",
        },
        { text: this.$t("start_validity"), value: "dateInz", type: "date" },
        { text: this.$t("end_validity"), value: "dateEnd", type: "date" },
        { text: "Certificati", value: "certificati", type: "certificatiCellComponent", saveFunction: "saveUserQualifica", disciplineItems: [] },
        { text: this.$t("diploma"), value: "diplomaAction", type: "buttons" },
      ],
      tableData: [],
    };
  },

  methods: {
    showUser(item) {
      this.$refs.profilePageDialog.open(item.masterId, 4);
    },
    saveUserQualifica(item) {
      let _ = this;
      if (!item || !item.callParms) return;

      const body = {
        masterId: item.masterId,
        asdTesId: item.asdTesId,
        stagione: item.stagione,
        disciplina: item.callParms.disciplina,
        livello: item.callParms.livello,
        certificati: item.callParms.certificati,
      };

      _.chiamataAxios("POST", "/auth/tesseramenti/saveUserQualifica", {
        msg: "always",
        body,
      }).then((response) => {
        if (response && response.msg && response.msg.esito) {
          _.loadTable();
        }
      });
    },
    openDiploma(item) {
      const diplomaUrl = item && (item.callParms || item.diplomaUrl);
      if (!diplomaUrl) return;
      this.$documentViewer.documentViewerRsp.docUrl = diplomaUrl;
    },
    loadDiscipline() {
      let _ = this;
      _.chiamataAxios("GET", "/auth/ente/listDiscipline").then((response) => {
        _.listDiscipline = response.data.map((disciplina) => ({
          value: disciplina.idDisciplina,
          text: disciplina.descr,
        }));

        const certHeader = _.headers.find((header) => header.type === "certificatiCellComponent");
        if (certHeader) {
          certHeader.disciplineItems = _.listDiscipline;
        }
      });
    },
    loadTable() {
      let _ = this;
      let filter = { type: _.filterStatus, validityDate: _.validityDate };
      _.tableData = [];
      _.chiamataAxios("POST", "/auth/tesseramenti/listUserCertificates", {
        body: { filter: filter },
      }).then((response) => {
        _.tableData = response.data.map(function (item) {
          item.tesseraEnte =
            '<h4 style="color: ' +
            item.asdTesHexColor +
            ';">' +
            item.asdTesTipo +
            (item.asdTesNum ? " - " + item.asdTesNum : "") +
            "</h4>";
          item.certificati = Array.isArray(item.certificati) ? item.certificati : [];
          item.diplomaAction = item.diplomaUrl
            ? [{
              icon: "mdi-certificate-outline",
              color: "success",
              function: "openDiploma",
              text: _.$t("diploma"),
              parms: item.diplomaUrl,
            }]
            : [];
          return item;
        });
      });
    },
  },
  mounted() {
    this.loadDiscipline();
    this.loadTable();
  },
  computed: {
    ifEnte: function () {
      return window.systemData && window.systemData.ifEnte
        ? window.systemData.ifEnte
        : false;
    },
  },
};
</script>

